import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createPrism(): DrawFn {
  const rng = mulberry32(42)
  const glints = Array.from({ length: 28 }, () => ({
    a: rng() * TAU,
    r: 36 + rng() * 110,
    s: 0.6 + rng() * 1.8,
    o: rng() * TAU,
    hue: 180 + rng() * 140,
  }))
  const rays = Array.from({ length: 7 }, () => ({
    a: -0.4 + rng() * 0.8,
    w: 0.008 + rng() * 0.018,
    hue: rng() * 360,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.38
    ctx.clearRect(0, 0, w, h)
    const intro = easeOutCubic(clamp(t / 1.2))

    ctx.globalCompositeOperation = 'lighter'

    const beam = ctx.createLinearGradient(cx, 0, cx, cy)
    beam.addColorStop(0, 'rgba(255,255,255,0)')
    beam.addColorStop(0.55, `rgba(220,240,255,${0.12 * intro})`)
    beam.addColorStop(1, `rgba(255,255,255,${0.28 * intro})`)
    ctx.fillStyle = beam
    ctx.beginPath()
    ctx.moveTo(cx - 4, 0)
    ctx.lineTo(cx + 4, 0)
    ctx.lineTo(cx + 22, cy)
    ctx.lineTo(cx - 22, cy)
    ctx.closePath()
    ctx.fill()

    glow(ctx, cx, cy, 90, `rgba(200,230,255,${0.14 * intro})`)

    for (const r of rays) {
      ctx.save()
      ctx.translate(cx, cy)
      ctx.rotate(r.a + Math.sin(t * 0.3) * 0.04)
      const len = Math.min(w, h) * 0.42
      const g = ctx.createLinearGradient(0, 0, len, 0)
      g.addColorStop(0, `hsla(${r.hue}, 80%, 75%, ${0.16 * intro})`)
      g.addColorStop(1, `hsla(${r.hue}, 80%, 75%, 0)`)
      ctx.fillStyle = g
      ctx.beginPath()
      ctx.moveTo(0, -r.w * 30)
      ctx.lineTo(len, -r.w * 160)
      ctx.lineTo(len, r.w * 160)
      ctx.lineTo(0, r.w * 30)
      ctx.closePath()
      ctx.fill()
      ctx.restore()
    }

    for (const g of glints) {
      const tw = 0.15 + 0.85 * Math.abs(Math.sin(t * 2.4 + g.o))
      const x = cx + Math.cos(g.a + t * 0.08) * g.r
      const y = cy + Math.sin(g.a + t * 0.08) * g.r * 0.82
      ctx.fillStyle = `hsla(${g.hue}, 85%, 78%, ${tw * 0.7 * intro})`
      ctx.beginPath()
      ctx.arc(x, y, g.s * tw, 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
